import { CommonModule } from "@angular/common";
import { Component, EventEmitter, inject, Input, Output } from "@angular/core";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatIconModule } from "@angular/material/icon";
import { Router } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";
import { PrefixEvent } from "src/app/components/global/prefixes/prefix.component";
import { LinkData } from "src/app/components/global/prefixes/templates/template-link/template-link.component";
import { DefaultComponent } from "src/app/default.component";
import { TooltipDirective } from "src/directives/tooltip.directive";
import { IconReplacePipe } from "src/pipes/icon-replace.pipe";
import { ApplicationService } from "src/services/application.service";
import { TableGroupAmountPipe } from "../../../../../../../pipes/table-group-amount.pipe";
import { TablePrefixComponent } from "../../../../../global/prefixes/containers/table-prefix/table-prefix.component";
import { TableGroup } from "../../../table-group";
import { TableHeader } from "../../../table-header";
import { TableRow } from "../../../table-row";
import { TableOptions } from "../../../table.interface";

@Component({
  selector: "app-table-list-view-group",
  imports: [
    CommonModule,
    MatIconModule,
    MatCheckboxModule,
    TablePrefixComponent,
    TranslateModule,
    MatExpansionModule,
    IconReplacePipe,
    TableGroupAmountPipe,
    TooltipDirective,
  ],
  templateUrl: "./table-list-view-group.component.html",
  styleUrl: "./table-list-view-group.component.less",
})
export class TableListViewGroupComponent extends DefaultComponent {
  @Input({ required: true })
  public headers: TableHeader[];
  @Input({ required: true })
  public group: TableGroup;
  @Input({ required: true })
  public options: TableOptions;

  @Output()
  public rowSelection: EventEmitter<void>;
  @Output()
  public prefixEvent: EventEmitter<[PrefixEvent, TableRow]>;
  @Output()
  public sort: EventEmitter<TableHeader>;

  private application = inject(ApplicationService);
  private router = inject(Router);

  public constructor() {
    super();
    this.headers = [];
    this.group = new TableGroup("");
    this.options = {
      head: true,
      foot: true,
      delete: false,
      archive: false,
      add: false,
      download: false,
      search: true,
      selectable: false,
      resultslimited: false,
      resultslimitedmaxreached: false,
      filter: false,
      map: false,
      tile: false,
      pageSize: 0,
      layout: null,
    };
    this.rowSelection = new EventEmitter();
    this.prefixEvent = new EventEmitter();
    this.sort = new EventEmitter();
  }

  public onRowClicked(event: MouseEvent, row: TableRow): void {
    let contentId: string | undefined;

    const link = row.fields.find((x) => x.name === "idpID");
    if (link && link.extras && "links" in link.extras) {
      const { links } = <{ links: LinkData[] }>link.extras;
      contentId = links.at(0)?.link;
    }

    if (contentId) {
      this.application.splitscreen.next(contentId);
    }
  }
}
